import { Component, Inject, OnInit, ViewChild , EventEmitter} from '@angular/core';
import { HandlerModal } from '../../handler-modals';
import { DAyudasFormularioNoExperto } from '../../../../../../configuracion/dayudas-formulario-no-experto';
import { MAT_DIALOG_DATA,MatDialogRef } from '@angular/material';
import { DDocumento } from '@dian/api-formulario';
import { DirectionType } from '../../handler-modals';
import { DOperacionesMatematicasServicio, DTipoOperacionAritmetica } from '@dian-cmp/formulario';
import { DNotificacionServicio } from '@dian-cmp/notificaciones';

const VAL_INDICADOR_COMPLETO="999";//Valor de referencia, si el indicador esta en este valor entonces ya paso todos los steps y el modal esta completo
const ID_CAS_INDICADOR_AVANCE='cs_id_702';
const stepsList = [
  { text: "1", active: true, completed: false, tooltip: 'Valor Total', listHelp: ['680'] },
  { text: "2", active: false, completed: false, tooltip: 'Vivienda Urbana?', listHelp: ['681'] },
  { text: "3", active: false, completed: false, tooltip: 'Valor Vivienda Urbana', listHelp: ['682'] },
  { text: "4", active: false, completed: false, tooltip: 'Vivienda Rural', listHelp: ['685'] },
  { text: "5", active: false, completed: false, tooltip: 'Valor Vivienda Rural', listHelp: ['686'] },
  { text: "6", active: false, completed: false, tooltip: 'Libros, ropa', listHelp: ['772'] },
  { text: "7", active: false, completed: false, tooltip: 'Donaciones, Herencias', listHelp: ['689'] },
  { text: "8", active: false, completed: false, tooltip: 'Liquidación sociedad conyugal', listHelp: ['690'] },
  { text: "9", active: false, completed: false, tooltip: 'Heredó otros inmuebles. ', listHelp: ['666'] }
  
];

@Component({
  selector: 'app-ganancias-ocasionales-herencia-modal',
  templateUrl: './ganancias-ocasionales-herencia-modal.component.html',
  styleUrls: ['./ganancias-ocasionales-herencia-modal.component.css'],
  providers: [
    DNotificacionServicio,
    DOperacionesMatematicasServicio
  ]
})
export class GananciasOcasionalesHerenciaModalComponent extends HandlerModal implements OnInit {

  @ViewChild('buttonRight') buttonRight: any;
  saveModel = new EventEmitter();
  public showSave:boolean;
  
  constructor(
    public dialogRef: MatDialogRef<GananciasOcasionalesHerenciaModalComponent>,
    public dutilidades:DOperacionesMatematicasServicio, 
    public dNotificacionServicio: DNotificacionServicio,
    @Inject(MAT_DIALOG_DATA) public model: DDocumento
  ) { 
    super(stepsList, DAyudasFormularioNoExperto.AYUDAS_FORMULARIO);
    console.log(model);
  }

  ngOnInit() {
    this.inicializeModelo();
    this.validateBtnRightActive();
    this.validateShowSave();
  }
  
  protected inicializeModelo(){
    if(this.model.doc.cuerpo.cs_id_680 == undefined)this.model.doc.cuerpo.cs_id_680="0";
    if(this.model.doc.cuerpo.cs_id_682 == undefined)this.model.doc.cuerpo.cs_id_682="0";
    if(this.model.doc.cuerpo.cs_id_662 == undefined)this.model.doc.cuerpo.cs_id_662="0";
    if(this.model.doc.cuerpo.cs_id_683 == undefined)this.model.doc.cuerpo.cs_id_683="0";
    if(this.model.doc.cuerpo.cs_id_686 == undefined)this.model.doc.cuerpo.cs_id_686="0";
    if(this.model.doc.cuerpo.cs_id_684 == undefined)this.model.doc.cuerpo.cs_id_684="0";
    if(this.model.doc.cuerpo.cs_id_687 == undefined)this.model.doc.cuerpo.cs_id_687="0";
    if(this.model.doc.cuerpo.cs_id_772 == undefined)this.model.doc.cuerpo.cs_id_772="0";
    if(this.model.doc.cuerpo.cs_id_689 == undefined)this.model.doc.cuerpo.cs_id_689="0";
    if(this.model.doc.cuerpo.cs_id_690 == undefined)this.model.doc.cuerpo.cs_id_690="0";
    if(this.model.doc.cuerpo.cs_id_666 == undefined)this.model.doc.cuerpo.cs_id_666="0";
  }

  
  ///////////////////////

  //Aplica si dentro del modal hay preguntas SI/NO que bloquean el avance
  public validateRbQuestions(val: string) {
    console.log(this.indexStepper + " - " +val);
    switch (this.indexStepper) {
      case 1:
        if(val == "0"){
          if(this.validateHasModalValues(this.indexStepper)){
            this.dNotificacionServicio.mostrarDialogoConfirmacion('Mensaje',"Está modificando su respuesta a 'No', pero ya existen datos ingresados para esta pregunta. Si confirma, los datos anteriores serán eliminados. ¿Está seguro de continuar?").afterClosed().subscribe(result => {
              if (result) {
                this.cleanModalValues(this.indexStepper);
                this.model.doc.cuerpo.cs_id_681 = val;
                //this.changeStepLocal(this.indexStepper+2);
              }
            });
          }else{
            this.model.doc.cuerpo.cs_id_681 = val;
          }
        }else{
          this.model.doc.cuerpo.cs_id_681 = val;
        }
        this.OperacionCs681();
        //Si ha seleccionado respuesta SI/NO habilitar botón next
        if(val!=undefined && val!=""){
          this.buttonRight.nativeElement.disabled = false;
        }
        break;

      case 3:
        if(val == "0"){
          if(this.validateHasModalValues(this.indexStepper)){
            this.dNotificacionServicio.mostrarDialogoConfirmacion('Mensaje',"Está modificando su respuesta a 'No', pero ya existen datos ingresados para esta pregunta. Si confirma, los datos anteriores serán eliminados. ¿Está seguro de continuar?").afterClosed().subscribe(result => {
              if (result) {
                this.cleanModalValues(this.indexStepper);
                this.model.doc.cuerpo.cs_id_685 = val;
                //this.changeStepLocal(this.indexStepper+2);
              }
            });
          }else{
            this.model.doc.cuerpo.cs_id_685 = val;
          }
        }else{
          this.model.doc.cuerpo.cs_id_685 = val;
        }
        this.OperacionCs685();
        //Si ha seleccionado respuesta SI/NO habilitar botón next
        if(val!=undefined && val!=""){
          this.buttonRight.nativeElement.disabled = false;
        }
        break;

      
      
    }
    console.log(this.model);
  }

  
  //Aplica para revisar si hay preguntas que se habilitaron con una previa respuesta SI en el modal
 
  protected validateHasModalValues(indexQuestion:number): boolean{
    let hasValues:boolean = false;
    switch(indexQuestion){//Pregunta Actualizar 
      case 1:
        if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_682, "0") ||
        this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_662, "0")
        ){
          hasValues=true;
        }
        break;
      case 3:
        if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_686, "0") ||
        this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_684, "0")
        ){
          hasValues=true;
        }

        break;
    }
    return hasValues;
  }

  //Aplica normalmente si se cambia el valor SI a NO en una pregunta del modal y deben eliminarse valores los valores previamente diligenciados
  protected cleanModalValues(indexQuestionModal:number){
    switch(indexQuestionModal){
      case 1:
        // this.model.doc.cuerpo.cs_id_683="0";
        this.model.doc.cuerpo.cs_id_683="0";
        this.model.doc.cuerpo.cs_id_682="0";
        this.model.doc.cuerpo.cs_id_662="0";
        break;
      case 3:
        this.model.doc.cuerpo.cs_id_686="0";
        this.model.doc.cuerpo.cs_id_684="0";
        this.model.doc.cuerpo.cs_id_687="0";
        break;
      default:
        break;
    }
    console.log(this.model);
  }
  
  //Aplica si dentro del modal existen condiciones que deshabilite el avance (como preguntas SI/NO)
  public validateStepHabilitado(indexS:number):boolean{
    let habilitado = true;
    //Si no ha respondido en vivienda urbana GO52 no puede saltar preguntas
    if( (indexS>=2 && indexS<=stepsList.length && (this.model.doc.cuerpo.cs_id_681==undefined || this.model.doc.cuerpo.cs_id_681=="")) ){
      habilitado = false;
    }
    //Si responde 'NO' en respondido en vivienda urbana GO52 debe saltar preguntas del indexStepper
    else if( (indexS==2 && indexS<=stepsList.length && (this.model.doc.cuerpo.cs_id_681=="0")) ){
      habilitado = false;
    }
     //Si no ha respondido en  en vivienda rural  GO54  no puede saltar preguntas
     if( (indexS>=4 && indexS<=stepsList.length && (this.model.doc.cuerpo.cs_id_685==undefined || this.model.doc.cuerpo.cs_id_685=="")) ){
      habilitado = false;
    }
    //Si responde 'NO' en respondido en  en vivienda rural  GO54  debe saltar preguntas del indexStepper
    else if( (indexS==4 && indexS<=stepsList.length && (this.model.doc.cuerpo.cs_id_685=="0")) ){
      habilitado = false;
    }
    return habilitado;
  }

  //Aplica si dentro del modal existen condiciones que deshabilite el avance (como preguntas SI/NO)
  public validateBtnRightActive(){
    //Si no se ha seleccionado respuesta SI/NO en go15CasaNacional deshabilitar botón next
    switch(this.indexStepper){
      case 1:
        //Si no se ha seleccionado respuesta SI/NO en go15CasaNacional deshabilitar botón next
        if( this.model.doc.cuerpo.cs_id_681==undefined || this.model.doc.cuerpo.cs_id_681=="" ){
          this.buttonRight.nativeElement.disabled = true;  
        }else{
          this.buttonRight.nativeElement.disabled = false;
        }
        break;
      case 3:
        //Si no se ha seleccionado respuesta SI/NO en go15CasaNacional deshabilitar botón next
        if( this.model.doc.cuerpo.cs_id_685==undefined || this.model.doc.cuerpo.cs_id_685=="" ){
          this.buttonRight.nativeElement.disabled = true;  
        }else{
          this.buttonRight.nativeElement.disabled = false;
        }
        break;
      default:
        this.buttonRight.nativeElement.disabled = false;
        break;
    }
  }
  

  public operaciones(numCas?:number,soloEstaCasilla?:boolean):void {
    switch (numCas) {
      case 680: this.OperacionCs680(); break;
      case 681: this.OperacionCs681(); break;//
      case 682: this.OperacionCs682(); break;
      case 662: this.OperacionCs662(); break;
      case 685: this.OperacionCs685(); break;//
      case 686: this.OperacionCs686(); break;
      case 684: this.OperacionCs684(); break;
      case 772: this.OperacionCs772(); break;
      case 689: this.OperacionCs689(); break;
      case 690: this.OperacionCs690(); break;
      case 666: this.OperacionCs666(); break;
   }
    if(soloEstaCasilla)return;

    //Operaciones3
    
    let resultado = "0";
    
  }




//HERENCIA O PORCION CONYUGAL

//(true;false); SI(C770 == false casillas GO5* se inicializan)
OperacionCs770(){
	const cas770 = this.model.doc.cuerpo.cs_id_770;
	if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES,cas770,"0")) {
		this.model.doc.cuerpo.cs_id_680="0";
		this.model.doc.cuerpo.cs_id_681=null;
		this.model.doc.cuerpo.cs_id_682="0";
		this.model.doc.cuerpo.cs_id_662="0";
		this.model.doc.cuerpo.cs_id_683="0";
		this.model.doc.cuerpo.cs_id_685=null;
		this.model.doc.cuerpo.cs_id_686="0";
		this.model.doc.cuerpo.cs_id_684="0";
		this.model.doc.cuerpo.cs_id_687="0";
		this.model.doc.cuerpo.cs_id_772="0";
		this.model.doc.cuerpo.cs_id_689="0";
		this.model.doc.cuerpo.cs_id_384="0";
		this.model.doc.cuerpo.cs_id_690="0";
		this.model.doc.cuerpo.cs_id_666="0";
		this.model.doc.cuerpo.cs_id_364="0";
	}
}

//Indique el valor total recibido por herencia o porción conyugal
//>0 ; Suma en C785
OperacionCs680(){
  if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE,this.model.doc.cuerpo.cs_id_680,"0")) {
	this.dNotificacionServicio.mostrarDialogoInformacion("Valor total de la herencia o porción conyugal debe ser mayor que cero");
    return
  }
}


//¿Heredó el inmueble de vivienda urbana del fallecido?
//(true;false); SI(C681 == false 682=0,C662=0,C683=0)
OperacionCs681(){
	if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES,this.model.doc.cuerpo.cs_id_681,"0")) {
		this.model.doc.cuerpo.cs_id_682="0";
		this.model.doc.cuerpo.cs_id_662="0";
		this.model.doc.cuerpo.cs_id_683="0";
	}
}

//Indique el valor que heredó por inmueble vivienda urbana
//>0;(C682+686+C773+C689+C690+C691) <= 680
OperacionCs682(){
  if(!this.validarTotal("cs_id_682"))return;
  this.OperacionCs683();
}

//Indique el porcentaje
//>= 1 <= 100
OperacionCs662(){
  if ( (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES,this.model.doc.cuerpo.cs_id_662,"0")) || 
       (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,this.model.doc.cuerpo.cs_id_662,"100"))) {
		this.dNotificacionServicio.mostrarDialogoInformacion("Porcentaje debe estar entre 1% y 100%");
		return
  }
    this.OperacionCs683();
}

//Parte exenta valor que heredó por inmueble vivienda urbana
//7770 uvt*C662/100+3490 uvt;  Si( > C682 ==> C682); ; Resta en C785
OperacionCs683(){

	const uvt7700 = "292631000";
	const uvt3490 = "132634000";
	
  let porcentaje = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.DIVISION,this.model.doc.cuerpo.cs_id_662,"100");
	
	let tope = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION,porcentaje,uvt7700);
  tope = this.dutilidades.redondearValorMoneda(tope);
  tope = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA,tope,uvt3490);

  if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,this.model.doc.cuerpo.cs_id_682,tope)) {
		this.model.doc.cuerpo.cs_id_683= tope;
	} else {
		this.model.doc.cuerpo.cs_id_683= this.model.doc.cuerpo.cs_id_682;

	}
}

//Heredó el inmueble rural del fallecido ?
//(true;false); SI(C685 == false 684=0; C687=0; C686)
OperacionCs685(){
	if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES,this.model.doc.cuerpo.cs_id_685,"0")) {
		this.model.doc.cuerpo.cs_id_684="0";
		this.model.doc.cuerpo.cs_id_687="0";
		this.model.doc.cuerpo.cs_id_686="0";
	}
}

//Indique el valor que heredó por inmueble rural
//>0;(C682+686+C773+C689+C690+C691) <= 680
OperacionCs686(){
  if(!this.validarTotal("cs_id_686"))return;
  this.OperacionCs687();
}

//Indique el porcentaje
//>= 1 <= 100
OperacionCs684(){
  if ( (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES,this.model.doc.cuerpo.cs_id_684,"0")) || 
       (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,this.model.doc.cuerpo.cs_id_684,"100"))) {
		this.dNotificacionServicio.mostrarDialogoInformacion("Porcentaje debe estar entre 1% y 100%");
		return
  }
  this.OperacionCs687();
}

//Parte no gravada que heredó por inmueble rural
//7770 uvt*C684/100+3490 uvt; (Si > C686 ==> C686); Resta en C785
OperacionCs687(){
	const uvt7700 = "292631000";
	const uvt3490 = "132634000";
	
  let porcentaje = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.DIVISION,this.model.doc.cuerpo.cs_id_684,"100");
	
	let tope = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION,porcentaje,uvt7700);
  tope = this.dutilidades.redondearValorMoneda(tope);
  tope =  this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA,tope,uvt3490);

  if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,this.model.doc.cuerpo.cs_id_686,tope)) {
		this.model.doc.cuerpo.cs_id_687= tope;
	} else {
		this.model.doc.cuerpo.cs_id_687= this.model.doc.cuerpo.cs_id_686;
	}
}


//Si recibió libros, ropa, utensilios de uso personal y mobiliario de la casa del fallecido, indique el valor total en pesos
//>=0;(C682+686+C772+C689+C690+C666) <= 680 ; Resta en C785
OperacionCs772(){
  if(!this.validarTotal("cs_id_772"))return;

}



//Si recibió donaciones, herencias (sólo por voluntad del fallecido) o cualquier ingreso por acto jurídico celebrado, sin incurrir en costos, indique el valor 
//>=0;(C682+686+C773+C689+C690+C691) <= 680
OperacionCs689(){
  if(!this.validarTotal("cs_id_689"))return;
  this.OperacionCs384();
}

//Parte exenta valor donaciones
//C689*0.2; Si > 2290 uvt ==> 2290 uvt ; Resta en C785
OperacionCs384(){
  const uvt2290 = "87029000";
  let valor = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION,this.model.doc.cuerpo.cs_id_689,"0.2");
  valor = this.dutilidades.redondearValorMoneda(valor);
  if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,valor,uvt2290)) {
		this.model.doc.cuerpo.cs_id_384= this.dutilidades.redondearValorMoneda(uvt2290);
	} else {
		this.model.doc.cuerpo.cs_id_384= valor;
	}
}

//Si recibió ingresos por liquidación de sociedad conyugal (gananciales), indique el valor total en pesos
//>=0;(C682+686+C773+C689+C690+C691) <= 680; Resta en C785
OperacionCs690(){
  if(!this.validarTotal("cs_id_690"))return;
}

//Si heredó otros inmuebles diferentes a inmueble vivienda urbana o inmueble rutal del causante. Indique el valor
//>=0;(C682+686+C773+C689+C690+C691) <= 680
OperacionCs666(){
  if(!this.validarTotal("cs_id_666"))return;
  this.OperacionCs364();
}

//Parte exenta valor que heredó de otros bienes inmuebles
//3490 uvt ; Si > C666 ==> C666; Resta en C785
OperacionCs364(){
	const uvt3490 = "132634000";
    if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,this.model.doc.cuerpo.cs_id_666,uvt3490)) {
		this.model.doc.cuerpo.cs_id_364= this.dutilidades.redondearValorMoneda(uvt3490);
	} else {
		this.model.doc.cuerpo.cs_id_364= this.model.doc.cuerpo.cs_id_666;
	}
}

validarTotal(cas?:string):boolean{
  let resultado = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA,this.model.doc.cuerpo.cs_id_682,this.model.doc.cuerpo.cs_id_686);
  resultado = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA,resultado,this.model.doc.cuerpo.cs_id_772);
  resultado = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA,resultado,this.model.doc.cuerpo.cs_id_689);
  resultado = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA,resultado,this.model.doc.cuerpo.cs_id_690);
  resultado = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA,resultado,this.model.doc.cuerpo.cs_id_666);
  this.model.doc.cuerpo.cs_id_372 = resultado;
  if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,resultado,this.model.doc.cuerpo.cs_id_680)) {
    this.dNotificacionServicio.mostrarDialogoInformacion("Valores registrados no pueden superar el valor total de la herencia o porción conyugal");
    if(cas!=undefined)this.model.doc.cuerpo[cas]="0";
    return false;
  }
  return true;
}


  //////////////////////////
  
  protected obtenerCasIndicadorAvance():string{
    if(this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]==undefined){
      this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]="0";
    }
    return this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE];
  }
  
  protected updateIndicadorAvance(){
    let casIndicadorAvance=this.obtenerCasIndicadorAvance();
    if(this.indexStepper> Number(casIndicadorAvance)){
      let indexS = this.indexStepper+1;
      while(!this.validateStepHabilitado(indexS)){
        indexS++;
      }
      this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]=indexS.toString();
    }
    if(this.indexStepper==this.stepsList.length-1){
      this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]=VAL_INDICADOR_COMPLETO;
    }
  }

  protected controlStep(direction: DirectionType): void {
    let indexS = this.indexStepper;
    while(!this.validateStepHabilitado(indexS)){
      if(direction==DirectionType.previous ){
          indexS--;
      }
      if(direction==DirectionType.next){
          indexS++;
      }
    }
    this.changeStepLocal(indexS, true);
  }

  public changeStepLocal(index: number, forceUpdateStepper?:boolean){
    let casIndicadorAvance=this.obtenerCasIndicadorAvance();
    if(forceUpdateStepper){
      this.changeStep(index);
      this.updateIndicadorAvance();
    }else if(this.validateStepHabilitado(index)){
      let indexCalc = index-1;
      if(indexCalc<=Number(casIndicadorAvance)){
        this.changeStep(index);
        this.updateIndicadorAvance();
      }else{
        console.log("Avance no permitido: casIndicadorAvance=" + casIndicadorAvance + ", index-1="+(indexCalc));
      }
    }
    this.validateBtnRightActive();
    this.validateShowSave();
  }

  protected validateShowSave(){
    if(this.indexStepper==this.stepsList.length-1 || this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]==VAL_INDICADOR_COMPLETO){ this.showSave=true };
  }

  public closeModal(){
    this.changeStepLocal(0);
    this.dialogRef.close("");
  }

  public guardar(){
    this.saveModel.emit(true);
    if(this.indexStepper==this.stepsList.length-1){
      this.closeModal();
    }
  }


}



// WEBPACK FOOTER //
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/formulario-no-experto/secciones/modales/ganancias-ocasionales/ganancias-ocasionales-herencia-modal/ganancias-ocasionales-herencia-modal.component.ts